export default "__VITE_ASSET__Ap6cNwcW__"